import React from 'react';
import { FormattedMessage,useIntl,createIntlCache,createIntl } from 'react-intl';
import messages from './messages'
const translateComponent = (id, value = {}) => <FormattedMessage id={id} values={{ ...value }} />;

export function useFormatMessage (messageId) {
  return useIntl().formatMessage({ id: messageId });
}

export default translateComponent;

const cache = createIntlCache()

const intl = createIntl({
  locale: 'ar-ar',
  messages:messages["ar-ar"]
}, cache)

export const translateMessage= (id) =>{
  const locale= localStorage.getItem('i18nLanguage') || "en-en"
  const intl = createIntl({
    locale,
    messages:messages[locale]
  }, cache)

  return intl.formatMessage({id})
}